module.exports = __webpack_public_path__ + "static/media/advantage2.25eadee6.png";